import { createContext } from 'react';
import useV1Data from '../hooks/useV1Data';

export const V1DataContext = createContext({});
export const V1DataContextProvider = ({ children, props }) => {
  const dataObject = useV1Data();
  // console.log('dataObject useV1Data')
  // console.log(dataObject)
  return (
    <V1DataContext.Provider
      value={{
        actions: {},
        state: {
          data: dataObject,
        },
      }}
      {...props}
    >
      {children}
    </V1DataContext.Provider>
  );
};
